import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

export default function ScrollToTop() {
  const location = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    // NavType 'POP' usually means the user clicked the back/forward button.
    // In this case, we rely on the browser's default scroll restoration.
    // Otherwise, we scrolled to the top for a new page ('PUSH' or 'REPLACE').
    if (navType !== 'POP') {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, navType]);

  return null;
}
